import React, { useState } from "react";
import { Link, useNavigate, useSearchParams } from "react-router-dom";
import api, { formatApiErrorDetail } from "../lib/api";
import { useLang } from "../lib/i18n";
import { LangToggle } from "../components/LangToggle";
import { Loader2 } from "lucide-react";

export default function ResetPassword() {
  const { t } = useLang();
  const [params] = useSearchParams();
  const token = params.get("token") || "";
  const nav = useNavigate();
  const [password, setPassword] = useState("");
  const [error, setError] = useState("");
  const [busy, setBusy] = useState(false);

  const submit = async (e) => {
    e.preventDefault();
    setBusy(true); setError("");
    try {
      await api.post("/auth/reset-password", { token, password });
      nav("/login", { replace: true });
    } catch (err) { setError(formatApiErrorDetail(err.response?.data?.detail)); }
    finally { setBusy(false); }
  };

  return (
    <div className="mx-auto flex min-h-screen max-w-md flex-col bg-white px-6 pt-6">
      <div className="flex justify-end"><LangToggle /></div>
      <h1 className="mt-10 font-display text-3xl font-extrabold text-slate-900">{t("reset_password")}</h1>
      <form onSubmit={submit} className="mt-8 space-y-4">
        <input data-testid="reset-password" type="password" required placeholder={t("new_password")} value={password} onChange={(e) => setPassword(e.target.value)}
          className="w-full rounded-xl border border-slate-200 bg-slate-50 px-4 py-3 text-sm outline-none focus:border-blue-500 focus:bg-white" />
        {error && <p data-testid="reset-error" className="text-sm font-medium text-rose-600">{error}</p>}
        <button data-testid="reset-submit" disabled={busy} className="flex w-full items-center justify-center gap-2 rounded-xl bg-blue-600 py-3 font-bold text-white transition hover:bg-blue-700 disabled:opacity-60">
          {busy && <Loader2 className="h-4 w-4 animate-spin" />}{t("reset_password")}
        </button>
      </form>
      <Link to="/login" className="mt-6 text-center text-sm font-semibold text-blue-600">{t("back_to_login")}</Link>
    </div>
  );
}
